module.exports = __webpack_public_path__ + "static/img/commplat.493c9aa3.png";